import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { ISendUserForgotPasswordOTPData } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the sent forgot password otp mutation keys in react query cache.
 */
const MUT_SEND_USER_FORGOT_PASSWORD_OTP = 'send-user-forgot-password-otp';

interface ISendUserLoginOTPOptions {
  onSuccessCallback: (otpData: ISendUserForgotPasswordOTPData) => void;
}

/**
 * This performs an otp generation request on the server that is sent to the
 * user's email.
 */
export const useSendUserForgotPasswordMutation = ({
  onSuccessCallback,
}: ISendUserLoginOTPOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_SEND_USER_FORGOT_PASSWORD_OTP],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.sendUserForgotPasswordOTP,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'Error in Sending Forgot Password OTP Attempt',
        message: err.message,
      });

      return err;
    },
  });

  return {
    error,
    isPending,
    sendForgotPasswordOTP: mutate,
  };
};
